import { render, staticRenderFns } from "./LateralMenu.vue?vue&type=template&id=825cbad2&scoped=true&"
import script from "./LateralMenu.vue?vue&type=script&lang=js&"
export * from "./LateralMenu.vue?vue&type=script&lang=js&"
import style0 from "./LateralMenu.vue?vue&type=style&index=0&id=825cbad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825cbad2",
  null
  
)

export default component.exports